import { isBulkPreOrderUpgrade, isBulkUpgrade, isNLD_OR_LL, isVPN_OR_DI, USER_TYPE, USER_TYPE_KAM } from 'common/constants/app.constants';
import { getFromSessionStorage, getCurrentServiceType, removeLastString, removeUnderScoreWithSpace, findParamFromUrl } from 'common/utils/app.utils';
import { alphaNumbericValidator, alphaValidatorWithSpaces, numberValidator } from 'common/utils/validator';
import { LEAD_STATUS, MODULE_ID } from 'home/common/constants/constants';
import { CART_ID, FILTER_TYPES, MULTI_SITE_MODULE_ID } from 'home/view/manage-feasibility/constants';
import { SORTTYPE_ENUM } from './table/custom-table.constant';

export const DEFAULT_FILE_NAME = 'Plan_Pricing_Configuration.xlsx';
export const IS_MULTIPLE_SORT = false;

export const KAM_META_DATA = 'KAM_META_DATA';

export const DEFAULT_FILE_PROPS = {
  name: 'file_add',
  label: 'Click or drop file to upload',
  placeholder: '',
  helpTexts: ['Supported file format is .xls • File size must be maximum 1mb '],
  required: false,
  accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel'
};

export const isUserTypeIsKAM = () => {
  const isKAMUser = findParamFromUrl('user') === USER_TYPE_KAM;
  return isKAMUser || getFromSessionStorage(MODULE_ID, USER_TYPE) === USER_TYPE_KAM;
};

export const CUSTOMER_MESSAGE = {
  NEED_ASSISTANCE: 'Your request for assistance has been sent to your Account Manager.',
  NEED_ASSISTANCE_CONTACT: 'You will be notified shortly.',
  EMAIl_PRICING: 'Email of the pricing proposal has been sent to your email ID',
  SITE_FILE_UPDATED_SUCCESS: 'file has been updated and saved on the system successfully.Please note that sites with non-standard IP is under review for pricing.',
  PRICE_UPDATED: 'The pricing of sites with non-standard IP/Hardware/Bandwidth is updated below',
  PRICE_UPDATED_TOAST: 'The pricing of sites is updated.Please check and proceed with the order.',
  INFO: 'Company agreed rates are displayed with standard configuration.If required, you may configure the sites with commercial attributes with help of Excel sheet.',
  INVALID_FORMAT: 'Invalid file format. Try to re-upload the correct format',
  INVALID_FILE: 'Errors found in the file. Download error file.',
  NONE_STANDARD_UNDER_REVIEW: 'Pricing under review. Your Account Manager will update you shortly.',
  SEND_TO_DOA: 'Order has been sent to CBH for approval since letter of intent was not uploaded.',
  PRICING_DOA_APPROVED: 'Order Approved by CBH.',
  PRE_ORDER_DOA_INFO: 'Please note that all the highlighted sites will go to the CBH for pricing review.',
  PRE_ORDER_PRICE_UPDATED_TOAST: 'Order Approved by CBH.Please check and proceed with the order.'
};

export const KAM_MESSAGE = {
  NEED_ASSISTANCE: 'Customer has requested for pricing assistance.Company agreed rates are displayed with standard configuration.',
  DOA_PRICING_REQUEST: 'Customised price is submitted for DOA approval.',
  DOA_CLARITY_REQUEST: 'DOA has requested for clarity on the customised price submitted.',
  KAM_SUBMIT_CLARITY: 'Clarity of customised pricing is submitted to DOA for approval.',
  DOA_APPROVED_PRICING: 'DOA has approved the customised pricing.',
  DOA_REJECTED_PRICING: 'DOA has rejected the customised pricing. Please revise the price again.',
  CUSTOMIZED_PRICING: 'Customer has requested for customized pricing.',
  SITE_FILE_UPDATED_SUCCESS: 'file has been updated and saved on the system successfully.'
};

export const KAM_MESSAGE_STATUS = {
  DOA_CLARITY_REQUEST: 'DOA has requested for clarity on the customised price submitted.',
  KAM_SUBMIT_CLARITY: 'Clarity on customised pricing is submitted.',
  DOA_APPROVED_PRICING: 'Customised pricing is approved by the DOA and is notified to the customer automatically.',
  DOA_REJECTED_PRICING: 'Customised pricing is rejected by the DOA.',
  CUSTOMIZED_PRICING: 'Customer has requested for customized pricing.',
  LEAD_SUBMITTED: 'Approved and will be notified to the customer automatically.',
  DOA_PRICING_REQUEST: 'Customised price is submitted to ',
  LOWER_PRICING_BW: 'The Annual Recurring Cost for the upgraded bandwidth is less than the current running Annual Recurring Cost. Please review the pricing.'
};

export const TOAST_TYPE = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error'
};

export const FILE_UPLOAD_ACTIONS = {
  PLAN_CONFIGURATION: 'PLAN_CONFIGURATION',
  FEASIBILITY: 'FEASIBILITY',
  PRICE_CONFIGURATION: 'PRICE_CONFIGURATION'
};

export const CONFIGURATION_TYPE = {
  DEFAULT: 'Default Configuration',
  CUSTOM: 'Custom Configuration'
};

const SPECS_KEY_LIST = ['routingProtocol', 'ipVersion', 'ipType', 'lanIPSubnet', 'wanIPSubnet', 'noOfLAN', 'noOfWAN'];

export const PROCEED_CONFIRMATION_ORDER_SUMMARY = {
  CONFIRMATION_TITLE: 'Proceed to Confirm Order Details',
  CONFIRMATION_MSG: 'Please note that there will be no change in order after proceeding to the next step. Are you sure you want to proceed?',
  NOTICE_TITLE: 'Notice',
  NOTICE_MSG:
    'Please note that the selected plan will be submitted to the account manager for the pricing review. You will be notified with the finalised pricing within 24hrs. Do you want to proceed?'
};

const numberValidatorForSearch = (value) => {
  if (value === '' || value === undefined) {
    return true;
  }
  const error = numberValidator(value);
  return error.length === 0 ? true : false;
};

const textValidatorForSearch = (value) => {
  if (value === '' || value === undefined) {
    return true;
  }
  const error = alphaValidatorWithSpaces(value);
  return error.length === 0 ? true : false;
};

export const SEARCH_OPTIONS = [
  {
    key: 'BANDWIDTH',
    displayName: 'Bandwidth',
    type: FILTER_TYPES.INPUT,
    apiKey: 'bandwidth',
    validator: numberValidatorForSearch
  },
  {
    key: 'MEDIA',
    displayName: 'Media Type',
    type: FILTER_TYPES.INPUT,
    apiKey: 'media',
    validator: textValidatorForSearch
  }
];

export const BULK_UPGRADE_SEARCH_OPTIONS = [
  {
    key: 'BANDWIDTH',
    displayName: 'Bandwidth',
    type: FILTER_TYPES.INPUT,
    apiKey: 'bandwidth',
    validator: numberValidatorForSearch
  }
];

const INFO_CONTENT = {
  CUSTOMER: 'Company agreed rates are displayed in the plans below.',
  KAM: ' Customer has requested for pricing/configuration assistance. Click on "Configure Sites with Excel" to edit the site level configurations and pricing in excel.'
};

export const getInfoContent = (requestId = '') => {
  return isUserTypeIsKAM() ? INFO_CONTENT.KAM : INFO_CONTENT.CUSTOMER;
};

export const MEDIA_TYPES_OTC = {
  THIRD_PARTY: 'Third Party',
  OFFNET: 'Offnet'
};

const getMediaType = (selectedMedia = []) => {
  if (Array.isArray(selectedMedia) && selectedMedia.length > 0) {
    return selectedMedia.length > 0 ? selectedMedia[0].media : '-';
  }
};

const getInstallationAddress = (content) => {
  return {
    address: getDashOrData(content.address && content.address.addressLine1),
    branchCode: getDashOrData(content.branchCode)
  };
};

const getRequiredBwInMbps = (content) => {
  const requiredBw = content.planDetail && content.planDetail.speed;
  const bwKey = 'Mbps';

  if (requiredBw) {
    if (requiredBw.includes(bwKey)) {
      return requiredBw;
    }

    return `${requiredBw} ${bwKey}`;
  }

  return '-';
};

export const existingARCGreaterThanNewARC = (content) => {
  let isGreater = false;

  const existingARC = content?.lsiDetail?.currentArc;
  const eligibleForRenewContract = content?.lsiDetail?.eligibleForRenewContract;
  const newARC = content?.planDetail?.price?.amount;

  if (!eligibleForRenewContract && existingARC > newARC) {
    isGreater = true;
  }

  return isGreater;
};

const getBulkUpgradeRowData = (content, mediaTypeObj) => {
  const { circuitId } = content;

  let requestedHardwareType = content?.lsiDetail?.requestedHardwareType;
  let requestedServiceType = content?.lsiDetail?.requestedServiceType;

  if (isUserTypeIsKAM()) {
    const requestedHardwareItem = content?.planDetail?.specs.find((item) => item.name === 'hardwareType');
    requestedHardwareType = requestedHardwareItem?.value;
    requestedServiceType = content?.planDetail?.service;
  }

  const getHardwareColumnData = () => {
    if (requestedServiceType === 'MANAGED') {
      return {
        data: getCurrentServiceType(requestedServiceType),
        subData: `${requestedHardwareType} Hardware`
      };
    }

    return {
      data: getCurrentServiceType(requestedServiceType),
      subData: '-'
    };
  };

  const getCurrentARC = (content) => {
    const defaultARC = getARPPrice(content.planDetail && content.planDetail.price);

    if (isUserTypeIsKAM()) {
      return defaultARC;
    }

    return existingARCGreaterThanNewARC(content) ? 'N/A' : defaultARC;
  };

  const getCurrentOTC = (content) => {
    const defaultOTC = getOTC(content.planDetail && content.planDetail.price);

    if (isUserTypeIsKAM()) {
      return defaultOTC;
    }

    return existingARCGreaterThanNewARC(content) ? 'N/A' : defaultOTC;
  };

  if (content) {
    return {
      lineItemId: getDashOrData(circuitId),
      installationAddress: getInstallationAddress(content),
      bandwidth: getRequiredBwInMbps(content),
      mediaType: getMediaType(content.selectedMedia),
      contractPeriod: getContractPeriod(content.planDetail),
      arp: getCurrentARC(content),
      otc: getCurrentOTC(content),
      rawContent: content,
      configurationType: getHardwareColumnData()
    };
  }
};

const mediatype = {
  Wireline: ['FTTH', 'Copper', 'Onnet', 'Offnet'],
  Wireless: ['RF', 'RF_P2P', 'RF_P2MP'],
  '4G': ['FOUR_G'],
  'Third Party': ['Third Party', 'TP']
};

const checkIfSameMediaType = (media) => {
  if (mediatype['Wireline'].indexOf(media) > -1) {
    return 'Wireline';
  }
  if (mediatype['Wireless'].indexOf(media) > -1) {
    return 'Wireless';
  }
  if (mediatype['4G'].indexOf(media) > -1) {
    return '4G';
  }
  if (mediatype['Third Party'].indexOf(media) > -1) {
    return 'Third Party';
  }
};

const isSameMediaFn = (linkId, mediaType, mediaTypeObj) => {
  if (checkIfSameMediaType(mediaTypeObj[linkId]) === checkIfSameMediaType(mediaType)) {
    return mediaType + ` *`;
  } else {
    mediaTypeObj[linkId] = mediaType;
    return mediaType;
  }
};

const checkIfDuplicate = (message) => {
  let splitStr = message?.split(' ');
  if (splitStr[1] === '*') {
    return true;
  } else {
    return false;
  }
};

const renderMessage = (message) => {
  if (message) {
    return <div class={checkIfDuplicate(message) ? `error` : ''}>{message}</div>;
  }
};

const getRowsForDI_VPN = (content, mediaTypeObj, isSameMedia) => {
  if (content) {
    const lastCharcterOfLineItem = `${content?.lineItemId ?? ''}`.charAt(content?.lineItemId?.length - 1);
    const isPrimaryOrSecondarySuffix = ['P', 'S'].includes(lastCharcterOfLineItem);
    return {
      id: content?.lineItemId,
      lineItemId: isPrimaryOrSecondarySuffix ? removeLastString(getDashOrData(content.lineItemId && content.lineItemId)) : getDashOrData(content.lineItemId && content.lineItemId),
      companyAddress: getDashOrData(content.address && content.address.addressLine1),
      installationAddress: getInstallationAddress(content),
      bandwidth: getDashOrData(content.planDetail && content.planDetail.speed),
      mediaType: isSameMedia
        ? renderMessage(getDashOrData(isSameMediaFn(removeLastString(content.lineItemId), getMediaType(content.selectedMedia), mediaTypeObj)))
        : getMediaType(content.selectedMedia),
      configurationType: getConfigurationType(content.planDetail),
      pricing: getPrice(content.planDetail && content.planDetail.price),
      arp: getARPPrice(content.planDetail && content.planDetail.price),
      otc: getOTC(content.planDetail && content.planDetail.price),
      contractPeriod: getContractPeriod(content.planDetail),
      preOrderDuration: content.preOrderDuration ? `${content.preOrderDuration} Days` : '-',
      rawContent: content,
      checkBox: { isChecked: false, text: '' },
      service: content?.planDetail && content?.planDetail.service,
      isRowSpanAllowed: content?.dualLastMile,
      siteType: content?.siteType
    };
  }
};

const getRowsForNLD_LL = (content) => {
  if (content) {
    return {
      id: content?.linkId,
      lineItemId: getDashOrData(content?.linkId && content?.linkId),
      companyAddress: getDashOrData(content.address && content.address.addressLine1),
      installationAddress: getInstallationAddress(content),
      bandwidth: getDashOrData(content.planDetail && content.planDetail.speed),
      mediaType: getDashOrData(getMediaType(content.selectedMedia)),
      pricing: getPrice(content.planDetail && content.planDetail.price),
      arp: getARPPrice(content.planDetail && content.planDetail.price),
      otc: getOTC(content.planDetail && content.planDetail.price),
      contractPeriod: getContractPeriod(content.planDetail),
      rawContent: content,
      service: content?.planDetail && content?.planDetail.service,
      siteType: removeUnderScoreWithSpace(content?.siteType),
      checkBox: { isChecked: false, text: '' },
      isRowSpanAllowed: true
    };
  }
};

export const convertToTableContent = (contents, mediaType, isSameMedia) => {
  if (Array.isArray(contents)) {
    return contents.map((content) => {
      if (isBulkUpgrade()) {
        if (isBulkPreOrderUpgrade()) {
          return getRowsForDI_VPN(content, mediaType, isSameMedia);
        }
        return getBulkUpgradeRowData(content, mediaType);
      }

      if (isNLD_OR_LL()) {
        return getRowsForNLD_LL(content);
      }

      return getRowsForDI_VPN(content, mediaType, isSameMedia);
    });
  }
  return [];
};

export const convertToLocationData = (data) => {
  const { bandwidth, pricing, mediaType, lineItemId: locationId } = data;
  return {
    companyName: data.rawContent.companyName,
    address: getDashOrData(data.rawContent.address && data.rawContent.address.addressLine1),
    mediaType: typeof mediaType !== 'string' ? mediaType?.props?.children : mediaType,
    pricing,
    bandwidth,
    locationId,
    rawContent: data.rawContent,
    service: data.rawContent.planDetail && data.rawContent.planDetail.service,
    ...getSpecsObject(data.rawContent.planDetail && data.rawContent.planDetail.specs),
    ...getRouterSpecs(data.rawContent.planDetail && data.rawContent.planDetail.routerSpecs),
    allRecords: data?.lineItems
  };
};

const getRouterSpecs = (routerSpecs) => {
  if (Array.isArray(routerSpecs)) {
    const result = {};
    routerSpecs.forEach((spec) => {
      if (spec) {
        result['cpe'] = spec.make;
        result['cpeSpecification'] = spec.model;
      }
    });
    return result;
  }
};

const getSpecsObject = (specs, key) => {
  if (Array.isArray(specs)) {
    const result = {};
    specs.forEach((spec) => {
      if (SPECS_KEY_LIST.includes(spec.name)) {
        result[spec.name] = spec.value;
      }
    });
    return result;
  }
};

const getPrice = (price) => {
  if (price && price.finalPrice) {
    return (price.amount + price.otc).toString();
  } else {
    return 'N/A';
  }
};

const getARPPrice = (price) => {
  return price ? (price.finalPrice ? price.amount : 'N/A').toString() : 'N/A';
};

const getOTC = (price) => {
  return price ? (price.finalPrice ? price.otc : 'N/A').toString() : 'N/A';
};

const getContractPeriod = ({ planPeriod = 0 } = { planPeriod: 0 }) => {
  return planPeriod ? `${Math.floor(planPeriod / 12)} ${Math.floor(planPeriod / 12) > 1 ? 'Years' : 'Year'}` : 'N/A';
};

const getDashOrData = (data) => {
  return data ? data.toString() : '-';
};

const getConfigurationType = (priceDetail) => {
  if (priceDetail) {
    return {
      value: priceDetail.defaultConfiguration ? CONFIGURATION_TYPE.DEFAULT : CONFIGURATION_TYPE.CUSTOM,
      rawContent: priceDetail
    };
  }
  return { value: '', rawContent: false };
};

const imageTypes = ['image/jpeg', 'image/jpg', 'image/png'];

export const isTypeOfImage = ({ type }) => {
  return imageTypes.includes(type);
};

export const DOA_STATUS = {
  CLARITY_REQUIRED: 'CLARITY_REQUIRED',
  IN_PROGRESS: 'IN_PROGRESS',
  CLARITY_SUBMITTED: 'CLARITY_SUBMITTED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED'
};

export const checkLeadSatus = (leadStatus) => {
  let status = false;
  if (
    leadStatus &&
    (leadStatus.toUpperCase() === LEAD_STATUS.FEASIBILITY_PENDING ||
      leadStatus.toUpperCase() === LEAD_STATUS.PNQ_IN_PROGRESS ||
      leadStatus.toUpperCase() === LEAD_STATUS.PNQ_COMPLETED)
  ) {
    status = true;
  } else if (leadStatus === 'PRICING_APPROVAL_REQUEST_SENT' || leadStatus === 'PRICING_DOA_REJECTED' || leadStatus === 'PRICING_DOA_APPROVED' || leadStatus === 'LEAD_CANCELLED') {
    status = true;
  }
  return status;
};

export const EDIT_CART_ACTION = {
  DELETE_SITE: 'DELETE_SITE',
  EDIT_CONTRACT_PERIOD: 'EDIT_CONTRACT_PERIOD',
  EDIT_PRE_ORDER_DURATION: 'EDIT_PRE_ORDER_DURATION',
  EDIT_SERVICE_TYPE: 'EDIT_SERVICE_TYPE',
  UPDATE_RATE_CARD: 'UPDATE_RATE_CARD'
};

export const getBulkEditRequest = (action, records = [], value) => {
  const request = {
    action,
    lineItemIds: [],
    cartId: getFromSessionStorage(MULTI_SITE_MODULE_ID, CART_ID) || '',
    value
  };
  records.forEach((record) => {
    if (request.lineItemIds.indexOf(record?.id) === -1) {
      request.lineItemIds.push(record?.id);
    }
  });
  return request;
};
